/* Presentation adapter for the existing UkfcQk form. No signup, consent,
   targeting, discount or Klaviyo event handlers are replaced. */
(() => {
  const selector = '[data-testid="klaviyo-form-UkfcQk"]';
  const headerImage = '9f95a914-2c32-454a-b8b7-b000f4732a73.png';
  const footerImage = '2772cea8-487c-48bf-a7f9-74cede0bfd44.png';
  const fr = document.documentElement.lang.startsWith('fr');
  const de = document.documentElement.lang.startsWith('de');
  function enhance(form) {
    // Only replace the known decorative signup artwork, never subsequent steps.
    const image = form.querySelector(`img[src*="${headerImage}"]`);
    const row = image?.closest('[data-testid="form-row"]');
    if (!row) return;
    if (!form.querySelector('.astra-welcome-copy')) {
      const copy = document.createElement('div');
      copy.className = 'astra-welcome-copy';
      const eyebrow = document.createElement('p');
      eyebrow.className = 'astra-welcome-eyebrow';
      eyebrow.textContent = 'APPROVED BY FRITZ';
      const heading = document.createElement('h2');
      heading.textContent = fr ? 'Bienvenue chez Fritz.' : de ? 'Gute Hunde. Tolle Vorteile.' : 'Good dogs. Great perks.';
      const description = document.createElement('p');
      description.textContent = fr ? 'Inscrivez-vous à la newsletter et profitez de 10 % de réduction.' : de ? 'Melde dich für den Fritz Newsletter an und erhalte 10 % Rabatt.' : 'Join the Fritz newsletter and get 10% off.';
      copy.append(eyebrow, heading, description);
      row.before(copy);
    }
    row.classList.add('astra-welcome-original');
    const footer = form.querySelector(`img[src*="${footerImage}"]`)?.closest('[data-testid="form-row"]');
    if (footer && !form.querySelector('.astra-welcome-note')) {
      const note = document.createElement('p');
      note.className = 'astra-welcome-note';
      note.append(fr ? 'Des nouvelles de Fritz par e-mail. Désinscription à tout moment. ' : de ? 'Fritz News per E-Mail. Jederzeit abmeldbar. ' : 'Fritz news by email. Unsubscribe anytime. ');
      const privacy = document.createElement('a');
      // Keep the active market/language using the existing footer policy link.
      privacy.href = document.querySelector('footer a[href*="/policies/privacy-policy"], [role="contentinfo"] a[href*="/policies/privacy-policy"]')?.href || '/policies/privacy-policy';
      privacy.textContent = fr ? 'Confidentialité' : de ? 'Datenschutz' : 'Privacy';
      note.append(privacy);
      footer.before(note);
    }
    footer?.classList.add('astra-welcome-original');
  }
  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(selector)) enhance(root);
    else if (root.closest(selector)) enhance(root.closest(selector));
    root.querySelectorAll(selector).forEach(enhance);
    const previewBar = root.matches('#PBarNextFrame') ? root : root.querySelector('#PBarNextFrame');
    if (previewBar && !previewBar.dataset.astraWelcomeObserved) {
      previewBar.dataset.astraWelcomeObserved = 'true';
      new ResizeObserver(() => document.documentElement.style.setProperty('--astra-preview-bar-height', `${Math.min(80,previewBar.getBoundingClientRect().height)}px`)).observe(previewBar);
    }
  }
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.body, {childList:true, subtree:true});
})();
